module.exports = __webpack_public_path__ + "img/icon.3381dcb7.svg";